var _rect, _rect2, _path, _rect3, _rect4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImageUploadIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.204187,
    y: 0.204187,
    width: 47.5916,
    height: 47.5916,
    rx: 23.7958,
    fill: "#121419"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.204187,
    y: 0.204187,
    width: 47.5916,
    height: 47.5916,
    rx: 23.7958,
    fill: "white",
    fillOpacity: 0.04
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 18.6335C16 17.7313 16.7313 17 17.6335 17H30.3665C31.2687 17 32 17.7313 32 18.6335V31.3665C32 32.2687 31.2687 33 30.3665 33H17.6335C16.7313 33 16 32.2687 16 31.3665V18.6335ZM21.3061 24.5204L18.3998 26.7C18.148 26.8888 17.9998 27.1853 17.9998 27.5L17.9999 30C17.9999 30.5523 18.4476 31 18.9999 31H28.9999C29.5522 31 29.9999 30.5523 29.9999 30V23.4142C29.9999 23.149 29.8945 22.8946 29.707 22.7071L29.6328 22.6329C29.2725 22.2726 28.6989 22.2408 28.301 22.5591L24.6988 25.4409C24.3009 25.7592 23.7273 25.7274 23.367 25.3671L22.6132 24.6133C22.2613 24.2614 21.7042 24.2218 21.3061 24.5204ZM20 23C21.1046 23 22 22.1046 22 21C22 19.8954 21.1046 19 20 19C18.8954 19 18 19.8954 18 21C18 22.1046 18.8954 23 20 23Z",
    fill: "#B7F84D",
    fillOpacity: 0.6
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 0.204187,
    y: 0.204187,
    width: 47.5916,
    height: 47.5916,
    rx: 23.7958,
    stroke: "#121419",
    strokeWidth: 0.408375
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 0.204187,
    y: 0.204187,
    width: 47.5916,
    height: 47.5916,
    rx: 23.7958,
    stroke: "white",
    strokeOpacity: 0.24,
    strokeWidth: 0.408375
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageUploadIcon);
export default __webpack_public_path__ + "static/media/image_upload_icon.71dc4c7a4647cff35641f944594e9400.svg";
export { ForwardRef as ReactComponent };